import { Model } from '@/models/Model'
import Property from '@/decorators/Property'

export class UserPageView extends Model {
	protected jsonApiType = 'userPageViews'

	@Property()
	public page!: string

	@Property()
	public lastSeenAt!: string
}
